import common from "./common.json";
import standardProduct from "./standardProduct.json";
import productInfo from "./productInfo.json";
import vendorInfo from "./vendorInfo.json";
import productSKU from "./productSKU.json";
import productPrice from "./productPrice.json";
import inventoryLevels from "./inventoryLevels.json";
import productTaxes from "./productTaxes.json";
import productCRV from "./productCRV.json";
import productAdditionalSections from "./productAdditionalSections.json";
import variantProduct from "./variantProduct.json";
import productVariant from "./productVariant.json";
import generateVariants from "./generateVariants.json";
import variantTable from "./variantTable.json";
import variantSpecificationsTab from "./variantSpecificationsTab.json";
import variantPriceTab from "./variantPriceTab.json";
import variantInventoryTab from "./variantInventoryTab.json";
import variantImagesTab from "./variantImagesTab.json";
import variantSKUTab from "./variantSKUTab.json";
import bundleProduct from "./bundleProduct.json";
import bundleProductInfo from "./bundleProductInfo.json";
import bundleProductPrice from "./bundleProductPrice.json";
import bundleProductTable from "./bundleProductTable.json";
import locationSummaryTable from "./locationSummaryTable.json";
import bundleProductSearchModal from "./bundleProductSearchModal.json";
import productBulkUpdate from "./productBulkUpdate.json";
import bulkUpdateVirtualTable from "./bulkUpdateVirtualTable.json";
import bulkPriceUpdateModal from "./bulkPriceUpdateModal.json";
import updatePriceModal from "./updatePriceModal.json";
import updateInventoryModal from "./updateInventoryModal.json";
import productsPage from "./productsPage.json";
import productDetails from "./productDetails.json";
import productSearchFilters from "./productSearchFilters.json";
import changeProductStatusModal from "./changeProductStatusModal.json";
import productLabelPrint from "./productLabelPrint.json";
import giftInfo from "./giftInfo.json";
import physicalGiftCard from "./physicalGiftCard.json";
import selectGiftCardDesignModal from "./selectGiftCardDesignModal.json";
import tagAlongProductModal from "./tagAlongProductModal.json";
import nonTaxableProducts from "./nonTaxableProducts.json";
import vendorInfoQty from "./vendorInfoQty.json";

const product = {
  common,
  standardProduct,
  productInfo,
  vendorInfo,
  productSKU,
  productPrice,
  inventoryLevels,
  productTaxes,
  productCRV,
  productAdditionalSections,
  variantProduct,
  productVariant,
  generateVariants,
  variantTable,
  variantSpecificationsTab,
  variantPriceTab,
  variantInventoryTab,
  variantImagesTab,
  variantSKUTab,
  bundleProduct,
  bundleProductInfo,
  bundleProductPrice,
  bundleProductTable,
  locationSummaryTable,
  bundleProductSearchModal,
  productBulkUpdate,
  bulkUpdateVirtualTable,
  bulkPriceUpdateModal,
  updatePriceModal,
  updateInventoryModal,
  productsPage,
  productDetails,
  productSearchFilters,
  changeProductStatusModal,
  productLabelPrint,
  giftInfo,
  physicalGiftCard,
  selectGiftCardDesignModal,
  tagAlongProductModal,
  nonTaxableProducts,
  vendorInfoQty,
};

export default product;
